export const NOTES_SECTION = {
  leadership_style_11: true,
}
